import { render, staticRenderFns } from "./ProductionListFloating.vue?vue&type=template&id=705be48e&scoped=true"
import script from "./ProductionListFloating.vue?vue&type=script&lang=js"
export * from "./ProductionListFloating.vue?vue&type=script&lang=js"
import style0 from "./ProductionListFloating.vue?vue&type=style&index=0&id=705be48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705be48e",
  null
  
)

export default component.exports